export const environment = {
    production: false,
    baseURL: 'https://urbanestate.nectica.com/api/v1'
};
